/**
 * Daily Belts buy box — qty packs + one swatch row with belt chips.
 * Replaces cloned dual color pickers (theme.js block is no-op when this runs).
 */
(function () {
  /**
   * Mobile qty row: edge fade + soft scroll peek.
   * - Product page: 5s after load
   * - Home page: 5s after the qty cards enter the viewport
   * Cancelled if the user scrolls the qty row first (no bounce).
   */
  function initQtyScrollDiscoverability() {
    var roots = document.querySelectorAll('[data-db-qty-scroll]');
    if (!roots.length) return;

    var PEEK_DELAY_MS = 5000;

    var isMobile = function () {
      return window.matchMedia('(max-width: 768px)').matches;
    };
    var prefersReduced = function () {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    };
    /** Homepage (featured product) vs product PDP */
    var isHomePage = function () {
      var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
      return path === '/';
    };

    /**
     * Animate scrollLeft with rAF — more reliable than scrollTo(smooth)
     * on overflow rows (and avoids scroll-snap fighting the nudge).
     */
    function animateScrollLeft(el, to, duration, done) {
      var from = el.scrollLeft;
      var delta = to - from;
      if (Math.abs(delta) < 1) {
        if (done) done();
        return;
      }
      var start = null;
      function easeInOut(t) {
        return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      }
      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        el.scrollLeft = from + delta * easeInOut(p);
        if (p < 1) {
          requestAnimationFrame(frame);
        } else if (done) {
          done();
        }
      }
      requestAnimationFrame(frame);
    }

    roots.forEach(function (root) {
      if (root.dataset.dbQtyScrollBound === '1') return;
      root.dataset.dbQtyScrollBound = '1';

      var track = root.querySelector('[data-db-qty-track], .custom_variant');
      var shell = root.querySelector('.db-qty-scroll') || root;
      if (!track) return;

      var peeking = false;
      var dismissed = false;
      var peekTimer = null;
      var peekScheduled = false;
      var prevSnap = '';

      function canScroll() {
        return track.scrollWidth > track.clientWidth + 4;
      }

      function atEnd() {
        return track.scrollLeft + track.clientWidth >= track.scrollWidth - 6;
      }

      function updateOverflowState() {
        if (!isMobile() || !canScroll()) {
          shell.classList.add('is-no-overflow');
          shell.classList.remove('is-at-end');
          return;
        }
        shell.classList.remove('is-no-overflow');
        shell.classList.toggle('is-at-end', atEnd());
      }

      function dismissHint() {
        if (dismissed) return;
        dismissed = true;
        shell.classList.add('is-hint-dismissed');
        if (peekTimer) {
          clearTimeout(peekTimer);
          peekTimer = null;
        }
        if (peeking) {
          track.style.scrollSnapType = prevSnap || '';
          peeking = false;
        }
      }

      function runPeek() {
        peekTimer = null;
        if (dismissed || !isMobile() || prefersReduced()) return;
        updateOverflowState();
        if (!canScroll()) return;
        /* User already scrolled the qty row — never bounce */
        if (track.scrollLeft > 4) {
          dismissHint();
          return;
        }

        peeking = true;
        prevSnap = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';

        var card = track.querySelector('.db-qty-card, .custom_variant_inner');
        var cardW = card ? card.getBoundingClientRect().width : 132;
        var peekPx = Math.round(Math.min(Math.max(cardW * 0.45, 48), 80));
        peekPx = Math.min(peekPx, track.scrollWidth - track.clientWidth);

        animateScrollLeft(track, peekPx, 480, function () {
          if (dismissed) {
            track.style.scrollSnapType = prevSnap || '';
            peeking = false;
            return;
          }
          setTimeout(function () {
            if (dismissed) {
              track.style.scrollSnapType = prevSnap || '';
              peeking = false;
              return;
            }
            animateScrollLeft(track, 0, 480, function () {
              track.style.scrollSnapType = prevSnap || '';
              peeking = false;
              updateOverflowState();
            });
          }, 380);
        });
      }

      /** Start the 5s countdown once (product: on load; home: when in view). */
      function schedulePeek() {
        if (peekScheduled || dismissed || !isMobile() || prefersReduced()) return;
        peekScheduled = true;
        peekTimer = setTimeout(runPeek, PEEK_DELAY_MS);
      }

      function onScroll() {
        updateOverflowState();
        if (peeking) return;
        if (track.scrollLeft > 10) {
          dismissHint();
        }
      }

      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener(
        'touchstart',
        function () {
          if (!peeking && track.scrollLeft > 2) dismissHint();
        },
        { passive: true }
      );
      track.addEventListener(
        'pointerdown',
        function () {
          if (!peeking && track.scrollLeft > 2) dismissHint();
        },
        { passive: true }
      );
      window.addEventListener(
        'resize',
        function () {
          updateOverflowState();
        },
        { passive: true }
      );

      updateOverflowState();
      requestAnimationFrame(function () {
        requestAnimationFrame(updateOverflowState);
      });
      window.addEventListener('load', updateOverflowState, { once: true });

      if (!isMobile() || prefersReduced()) return;

      if (isHomePage()) {
        /* Home: only start 5s timer after user scrolls qty cards into view */
        if (typeof IntersectionObserver === 'undefined') {
          schedulePeek();
          return;
        }
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting && entries[i].intersectionRatio >= 0.35) {
                schedulePeek();
                io.disconnect();
                break;
              }
            }
          },
          { threshold: [0, 0.35, 0.5, 0.75] }
        );
        io.observe(root);
      } else {
        /* Product (and other pages): 5s after ready */
        schedulePeek();
      }
    });
  }

  function boot() {
    var formRoot = document.querySelector('[data-db-color-picker], Belt-varinat-form, belt-varinat-form');
    if (!formRoot || formRoot.dataset.dbChipsBound === '1') return;
    formRoot.dataset.dbChipsBound = '1';

    var chipsEl = formRoot.querySelector('[data-db-color-chips]');
    var hintEl = formRoot.querySelector('[data-db-color-hint]');
    var errorEl = formRoot.querySelector('.color_error');
    var soldOutEl = formRoot.querySelector('.sold_out_color');
    var swatchForms = Array.prototype.slice.call(formRoot.querySelectorAll('.belt_varinat_form'));
    var qtyBlocks = Array.prototype.slice.call(document.querySelectorAll('.custom_variant_inner'));

    if (!chipsEl || !swatchForms.length || !qtyBlocks.length) return;

    var PACK_PLUS_MIN = 4;
    var PACK_PLUS_MAX = 8;
    var quantity = 1;
    var activeSlot = 0;
    /** When true, qty card is 4+ (expandable 4–8). */
    var packPlus = false;
    /** @type {Array<{id:string,title:string,qty:number}|null>} */
    var selections = [];
    /** Double-tap tracking for mobile remove */
    var lastTapSlot = -1;
    var lastTapAt = 0;
    var DOUBLE_TAP_MS = 380;
    /** Slot index to play pop-in animation on next render (−1 = none) */
    var popSlotIndex = -1;

    var resetBtn = formRoot.querySelector('[data-db-color-reset]');
    var removeHintEl = formRoot.querySelector('[data-db-remove-hint]');
    var packPlusBlock = document.querySelector('.custom_variant_quantity4[data-pack-plus]');

    function clickFirstThumbnail() {
      var first = document.querySelector('.product-gallery__thumbnail-list .product-gallery__thumbnail');
      if (first) first.click();
    }

    function parseQty(block) {
      var el = block.querySelector('[data-show-quanity]');
      return parseInt(el && el.dataset.showQuanity ? el.dataset.showQuanity : '1', 10) || 1;
    }

    function isPackPlusBlock(block) {
      return !!(block && (block.dataset.packPlus === 'true' || block.getAttribute('data-pack-plus') === 'true'));
    }

    function packPlusLimits(block) {
      var b = block || packPlusBlock;
      var min = parseInt((b && b.dataset.packMin) || String(PACK_PLUS_MIN), 10) || PACK_PLUS_MIN;
      var max = parseInt((b && b.dataset.packMax) || String(PACK_PLUS_MAX), 10) || PACK_PLUS_MAX;
      return { min: min, max: max };
    }

    function filledCount() {
      var n = 0;
      for (var i = 0; i < quantity; i++) {
        if (selections[i]) n++;
      }
      return n;
    }

    function allSlotsFilled() {
      if (quantity < 1) return false;
      for (var i = 0; i < quantity; i++) {
        if (!selections[i]) return false;
      }
      return true;
    }

    function firstEmptySlot() {
      for (var i = 0; i < quantity; i++) {
        if (!selections[i]) return i;
      }
      return Math.max(0, quantity - 1);
    }

    function updatePackPlusCard(nOverride) {
      if (!packPlusBlock) return;
      var limits = packPlusLimits(packPlusBlock);
      var label = packPlusBlock.querySelector('[data-db-qty4-label]');
      var n =
        typeof nOverride === 'number'
          ? nOverride
          : packPlus
            ? quantity
            : limits.min;
      n = Math.max(limits.min, Math.min(limits.max, n));

      if (label) {
        label.textContent = 'Quantity: ' + n + '+';
        label.setAttribute('data-show-quanity', String(limits.min));
      }
      /* Keep base parse qty at min so Q4 card identity stays 4+ */
      packPlusBlock.setAttribute('data-show-quanity', String(limits.min));
    }

    function setQuantity(q) {
      var prevQty = quantity;
      var nextQty = Math.max(1, q | 0);
      if (packPlus) {
        var limits = packPlusLimits();
        nextQty = Math.max(limits.min, Math.min(limits.max, nextQty));
      }

      /*
        Keep colors for belts that still exist.
        Increasing: preserve existing, leave new slots empty.
        Decreasing: drop trailing picks.
      */
      var next = [];
      for (var i = 0; i < nextQty; i++) {
        next[i] = selections[i] || null;
      }
      selections = next;
      quantity = nextQty;

      if (nextQty > prevQty) {
        activeSlot = firstEmptySlot();
      } else if (nextQty < prevQty) {
        activeSlot = Math.max(0, nextQty - 1);
      } else if (activeSlot >= nextQty) {
        activeSlot = Math.max(0, nextQty - 1);
      }

      if (packPlus) updatePackPlusCard();
      renderChips();
      syncSwatches();
      updateHint();
      updateResetVisibility();
      updateStickyAtc();
      hideErrors();
    }

    function hideErrors() {
      if (errorEl) errorEl.style.display = 'none';
      if (soldOutEl) soldOutEl.style.display = 'none';
      clearIncompletePulse();
    }

    function clearIncompletePulse() {
      formRoot.classList.remove('is-incomplete-pulse');
      chipsEl.querySelectorAll('.db-color-chip.is-empty-pulse').forEach(function (el) {
        el.classList.remove('is-empty-pulse');
      });
    }

    function emptySlotCount() {
      var n = 0;
      for (var i = 0; i < quantity; i++) {
        if (!selections[i] || !selections[i].id) n++;
      }
      return n;
    }

    /**
     * Incomplete ATC: focus first empty chip, pulse empties, scroll color section into view.
     */
    function guideIncompleteColors() {
      if (quantity <= 1) {
        activeSlot = 0;
        renderChips();
        syncSwatches();
        return;
      }

      var emptyIdx = firstEmptySlot();
      /* firstEmptySlot returns last index if all filled — only use if truly empty */
      if (selections[emptyIdx] && selections[emptyIdx].id) {
        for (var i = 0; i < quantity; i++) {
          if (!selections[i] || !selections[i].id) {
            emptyIdx = i;
            break;
          }
        }
      }
      activeSlot = emptyIdx;

      renderChips();
      syncSwatches();
      updateHint();

      /* Pulse empty chips */
      formRoot.classList.add('is-incomplete-pulse');
      chipsEl.querySelectorAll('.db-color-chip').forEach(function (chip) {
        var slot = parseInt(chip.dataset.slot, 10);
        if (!selections[slot] || !selections[slot].id) {
          chip.classList.add('is-empty-pulse');
        }
      });

      /* Bring color section into view (mobile ATC below fold) */
      try {
        formRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        formRoot.scrollIntoView(true);
      }

      /* Clear pulse after a few cycles so UI settles */
      clearTimeout(formRoot.__dbPulseTimer);
      formRoot.__dbPulseTimer = setTimeout(function () {
        clearIncompletePulse();
      }, 2800);
    }

    function updateHint() {
      if (!hintEl) return;
      if (quantity <= 1) {
        hintEl.textContent = selections[0] ? '· ' + selections[0].title : '· Choose a color';
      } else {
        hintEl.textContent = '· ' + filledCount() + ' of ' + quantity + ' selected';
      }
      if (removeHintEl) {
        var showRemoveHint = packPlus && quantity > PACK_PLUS_MIN;
        removeHintEl.hidden = !showRemoveHint;
      }
    }

    function updateResetVisibility() {
      if (!resetBtn) return;
      var any = false;
      for (var i = 0; i < selections.length; i++) {
        if (selections[i]) {
          any = true;
          break;
        }
      }
      /* Also show reset when pack-plus grew past floor (extra empty slots to wipe) */
      if (packPlus && quantity > PACK_PLUS_MIN) any = true;
      resetBtn.hidden = !any;
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function swatchStyleFor(sel) {
      if (!sel) return '';
      var match = swatchForms.find(function (f) {
        var v = f.querySelector('.belt_variant_custom');
        return v && v.dataset.variantId === sel.id;
      });
      var bg = match && match.querySelector('.belt_variant_custom');
      return bg && bg.getAttribute('style') ? bg.getAttribute('style') : '';
    }

    /** Extract image URL only — avoid copying full `background:` (breaks round clip). */
    function swatchBgUrl(sel) {
      var style = swatchStyleFor(sel);
      if (!style) return '';
      var m = String(style).match(/url\(\s*(['"]?)(.*?)\1\s*\)/i);
      return m && m[2] ? m[2] : '';
    }

    function urlFromStyleAttr(style) {
      if (!style) return '';
      var m = String(style).match(/url\(\s*(['"]?)(.*?)\1\s*\)/i);
      return m && m[2] ? m[2] : '';
    }

    /** Smokescreen keeps fabric texture; all other colors use sampled solid fills. */
    function isSmokescreenTitle(title) {
      return /smoke\s*screen|smokescreen/i.test(String(title || ''));
    }

    /** Light belt names need dark text + light scrim (fallback if sample not ready). */
    function isLightSwatchTitle(title) {
      return /white|ivory|cream|snow|bone|sand|dune|beige|tan|khaki|natural|oat|linen|stone|pearl|cloud|ash\b|fog|grey|gray|silver|champagne|wheat|nude|blush/i.test(
        String(title || '')
      );
    }

    /** @type {Object.<string, {hex:string,r:number,g:number,b:number,lum:number}|null>} */
    var swatchColorCache = {};

    function rgbToHex(r, g, b) {
      return (
        '#' +
        [r, g, b]
          .map(function (n) {
            var h = Math.max(0, Math.min(255, n | 0)).toString(16);
            return h.length === 1 ? '0' + h : h;
          })
          .join('')
      );
    }

    /**
     * Average center of a swatch image → solid chip fill color.
     * Uses CORS; on failure cache null and fall back to texture/title heuristics.
     */
    function sampleImageColor(url, cb) {
      if (!url) {
        cb(null);
        return;
      }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var size = 40;
          var canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          var ctx = canvas.getContext('2d');
          if (!ctx) {
            cb(null);
            return;
          }
          ctx.drawImage(img, 0, 0, size, size);
          /* Center 60% avoids edge artifacts */
          var x0 = Math.floor(size * 0.2);
          var y0 = Math.floor(size * 0.2);
          var w = Math.floor(size * 0.6);
          var data = ctx.getImageData(x0, y0, w, w).data;
          var r = 0;
          var g = 0;
          var b = 0;
          var n = 0;
          for (var i = 0; i < data.length; i += 4) {
            if (data[i + 3] < 140) continue;
            r += data[i];
            g += data[i + 1];
            b += data[i + 2];
            n++;
          }
          if (!n) {
            cb(null);
            return;
          }
          r = Math.round(r / n);
          g = Math.round(g / n);
          b = Math.round(b / n);
          var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
          cb({ hex: rgbToHex(r, g, b), r: r, g: g, b: b, lum: lum });
        } catch (err) {
          cb(null);
        }
      };
      img.onerror = function () {
        cb(null);
      };
      /* Cache-bust not needed; shop CDN usually allows anonymous CORS */
      img.src = url;
    }

    function ensureSwatchColors(done) {
      var pending = 0;
      var settled = 0;
      function check() {
        if (settled >= pending && typeof done === 'function') done();
      }
      swatchForms.forEach(function (form) {
        var custom = form.querySelector('.belt_variant_custom');
        if (!custom) return;
        var id = custom.dataset.variantId;
        if (!id || Object.prototype.hasOwnProperty.call(swatchColorCache, id)) return;
        var url = urlFromStyleAttr(custom.getAttribute('style'));
        if (!url) {
          swatchColorCache[id] = null;
          return;
        }
        pending++;
        sampleImageColor(url, function (color) {
          swatchColorCache[id] = color;
          settled++;
          check();
        });
      });
      if (!pending && typeof done === 'function') done();
    }

    /** True when ✕ / double-tap may remove a belt slot (4+ only, more than 4 chips). */
    function canRemoveBeltSlots() {
      return packPlus && quantity > PACK_PLUS_MIN;
    }

    /**
     * Remove a belt slot (4+ with 5–8 only).
     * Never clears a color in place — change color by selecting the chip, then a swatch.
     */
    function removeAtSlot(index) {
      if (index < 0 || index >= quantity) return;
      if (!canRemoveBeltSlots()) return;
      hideErrors();

      selections.splice(index, 1);
      quantity -= 1;
      if (activeSlot >= quantity) activeSlot = Math.max(0, quantity - 1);
      else if (activeSlot > index) activeSlot -= 1;
      updatePackPlusCard();

      lastTapSlot = -1;
      lastTapAt = 0;
      renderChips();
      syncSwatches();
      updateHint();
      updateResetVisibility();
      updateStickyAtc();
    }

    /** + chip: append empty belt when all filled and under max */
    function addEmptyBelt() {
      var limits = packPlusLimits();
      if (!packPlus || quantity >= limits.max || !allSlotsFilled()) return;
      selections.push(null);
      quantity += 1;
      activeSlot = quantity - 1;
      popSlotIndex = activeSlot; /* new chip pops/grows in place of + */
      updatePackPlusCard();
      renderChips();
      syncSwatches();
      updateHint();
      updateResetVisibility();
      updateStickyAtc();
    }

    function resetSelections() {
      hideErrors();
      if (packPlus) {
        quantity = PACK_PLUS_MIN;
        selections = [];
        for (var i = 0; i < quantity; i++) selections[i] = null;
        updatePackPlusCard();
      } else {
        for (var j = 0; j < quantity; j++) selections[j] = null;
      }
      activeSlot = 0;
      lastTapSlot = -1;
      lastTapAt = 0;
      renderChips();
      syncSwatches();
      updateHint();
      updateResetVisibility();
      updateStickyAtc();
    }

    function renderChips() {
      chipsEl.innerHTML = '';
      chipsEl.hidden = false;
      formRoot.classList.toggle('is-multi', quantity > 1);
      formRoot.classList.toggle('is-qty-2', quantity === 2);
      formRoot.classList.toggle('is-qty-3', quantity === 3);
      formRoot.classList.toggle('is-qty-4', quantity === 4 && !packPlus);
      formRoot.classList.toggle('is-pack-plus', packPlus);
      formRoot.classList.toggle('is-qty-plus', packPlus);
      formRoot.setAttribute('data-qty', String(quantity));
      chipsEl.dataset.chipCount = String(quantity);
      chipsEl.setAttribute('data-chip-count', String(quantity));
      if (packPlus) chipsEl.setAttribute('data-pack-plus', 'true');
      else chipsEl.removeAttribute('data-pack-plus');

      for (var i = 0; i < quantity; i++) {
        (function (slotIndex) {
          var sel = selections[slotIndex];
          var chip = document.createElement('button');
          chip.type = 'button';
          var bgUrl = swatchBgUrl(sel);
          var sampled = sel && swatchColorCache[sel.id] ? swatchColorCache[sel.id] : null;
          var useTexture = !!(sel && isSmokescreenTitle(sel.title) && bgUrl);
          var useSolid = !!(sel && !useTexture && sampled && sampled.hex);
          var lightFill = false;
          if (useSolid) {
            lightFill = sampled.lum > 0.52;
          } else if (sel) {
            lightFill = isLightSwatchTitle(sel.title);
          }
          var hasFill = !!(useTexture || useSolid || (sel && bgUrl));
          chip.className =
            'db-color-chip' +
            (slotIndex === activeSlot ? ' is-active' : '') +
            (sel ? ' is-filled' : '') +
            (hasFill ? ' has-swatch-bg' : '') +
            (useSolid ? ' has-swatch-solid' : '') +
            (useTexture ? ' has-swatch-texture' : '') +
            (lightFill ? ' is-light-swatch' : '') +
            (slotIndex === popSlotIndex ? ' is-pop-in' : '');
          chip.setAttribute('aria-pressed', slotIndex === activeSlot ? 'true' : 'false');
          chip.dataset.slot = String(slotIndex);

          /*
            Smokescreen → fabric texture.
            All other colors → average sampled solid from swatch image.
          */
          chip.style.backgroundImage = '';
          chip.style.backgroundColor = '';
          if (useTexture) {
            chip.style.backgroundImage = 'url(' + JSON.stringify(String(bgUrl)) + ')';
          } else if (useSolid) {
            chip.style.backgroundColor = sampled.hex;
          } else if (sel && bgUrl) {
            /* Sample still loading / failed — temporary texture */
            chip.style.backgroundImage = 'url(' + JSON.stringify(String(bgUrl)) + ')';
          }

          /* ✕ only on 4+ when more than 4 chips — removes the belt, does not clear color */
          var removeBtn = '';
          if (canRemoveBeltSlots()) {
            removeBtn =
              '<span class="db-color-chip__remove" role="button" tabindex="-1" aria-label="Remove belt ' +
              (slotIndex + 1) +
              '" data-db-chip-remove="' +
              slotIndex +
              '">×</span>';
          }

          chip.innerHTML =
            removeBtn +
            '<span class="db-color-chip__scrim" aria-hidden="true"></span>' +
            '<span class="db-color-chip__text">' +
            '<span class="db-color-chip__label">Belt ' +
            (slotIndex + 1) +
            '</span>' +
            '<span class="db-color-chip__value">' +
            (sel ? escapeHtml(sel.title) : 'Choose color') +
            '</span></span>';

          chip.addEventListener('click', function (e) {
            var removeEl = e.target.closest('[data-db-chip-remove]');
            if (removeEl && canRemoveBeltSlots()) {
              e.preventDefault();
              e.stopPropagation();
              removeAtSlot(slotIndex);
              return;
            }

            var now = Date.now();
            /* Mobile double-tap removes belt only when 4+ has more than 4 chips */
            if (
              canRemoveBeltSlots() &&
              lastTapSlot === slotIndex &&
              now - lastTapAt <= DOUBLE_TAP_MS
            ) {
              e.preventDefault();
              removeAtSlot(slotIndex);
              return;
            }
            lastTapSlot = slotIndex;
            lastTapAt = now;

            activeSlot = slotIndex;
            renderChips();
            syncSwatches();
          });

          chipsEl.appendChild(chip);
        })(i);
      }

      /* + add chip: only when pack-plus, all filled, under max */
      var limits = packPlusLimits();
      if (packPlus && quantity < limits.max && allSlotsFilled()) {
        var addBtn = document.createElement('button');
        addBtn.type = 'button';
        /* Standalone class — do not use .db-color-chip (pill styles stretch it oval) */
        addBtn.className = 'db-color-add';
        addBtn.setAttribute('aria-label', 'Add another belt');
        addBtn.innerHTML = '<span class="db-color-add__plus" aria-hidden="true">+</span>';
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          addEmptyBelt();
        });
        chipsEl.appendChild(addBtn);
      }

      /* Pop only once per added chip */
      popSlotIndex = -1;
    }

    function syncSwatches() {
      var active = selections[activeSlot];
      swatchForms.forEach(function (form) {
        var custom = form.querySelector('.belt_variant_custom');
        var id = custom && custom.dataset.variantId;
        var inv = parseInt((custom && custom.dataset.varinatQuantity) || '0', 10);
        form.classList.toggle('belt_varinat_form_select', !!(active && active.id === id));
        if (inv <= 0) {
          form.classList.add('variant_disabled');
          form.style.opacity = '0.5';
        }
      });
    }

    function selectVariantForActiveSlot(form) {
      var custom = form.querySelector('.belt_variant_custom');
      if (!custom) return;

      var id = custom.dataset.variantId;
      var title = custom.dataset.variantTitle || '';
      var inv = parseInt(custom.dataset.varinatQuantity || '0', 10);

      hideErrors();

      if (inv <= 0) {
        if (soldOutEl) {
          var soldColor = soldOutEl.querySelector('.sold_color');
          if (soldColor) soldColor.textContent = title;
          soldOutEl.style.display = 'inline-flex';
          soldOutEl.style.color = 'red';
        }
        return;
      }

      var pick = { id: id, title: title, qty: inv };
      var limits = packPlusLimits();
      var wasAllFull = allSlotsFilled();

      /*
        Pack-plus: if every chip is already filled and under max, grow with this color.
        Otherwise assign to active slot (fill empty or replace filled).
      */
      if (packPlus && wasAllFull && quantity < limits.max) {
        selections.push(pick);
        quantity += 1;
        activeSlot = quantity - 1;
        popSlotIndex = activeSlot;
        updatePackPlusCard();
      } else {
        selections[activeSlot] = pick;
        if (quantity > 1) {
          var nextEmpty = -1;
          for (var i = 0; i < quantity; i++) {
            var idx = (activeSlot + 1 + i) % quantity;
            if (!selections[idx]) {
              nextEmpty = idx;
              break;
            }
          }
          if (nextEmpty >= 0) activeSlot = nextEmpty;
        }
      }

      clearIncompletePulse();
      renderChips();
      syncSwatches();
      updateHint();
      updateResetVisibility();
      updateStickyAtc();
      updateGallery(id);
    }

    function updateGallery(variantId) {
      var featuredMedia = window.variantMedia && window.variantMedia[variantId];
      if (featuredMedia && featuredMedia.position) {
        var thumbs = document.querySelectorAll(
          '.product-gallery__thumbnail-list .product-gallery__thumbnail'
        );
        var target = thumbs[featuredMedia.position - 1];
        if (target) target.click();
      }
      if (featuredMedia && featuredMedia.id) {
        var mediaToActivate = document.querySelector('[data-media-id="' + featuredMedia.id + '"]');
        if (mediaToActivate) {
          document
            .querySelectorAll(
              'product-gallery media-gallery media-image, product-gallery media-gallery .media'
            )
            .forEach(function (slide) {
              slide.removeAttribute('active');
            });
          mediaToActivate.setAttribute('active', '');
        }
      }
    }

    function validate(showErrors) {
      var ok = true;
      for (var i = 0; i < quantity; i++) {
        if (!selections[i] || !selections[i].id) {
          ok = false;
          break;
        }
        if (selections[i].qty <= 0) {
          ok = false;
          break;
        }
      }
      if (!ok && showErrors) {
        if (errorEl) {
          errorEl.style.display = 'inline';
          var emptyN = emptySlotCount();
          if (quantity <= 1) {
            errorEl.textContent = 'Please select a color';
          } else if (filledCount() > 0 && emptyN > 0) {
            errorEl.textContent =
              emptyN === 1
                ? 'Pick a color for the remaining belt'
                : 'Pick colors for the remaining ' + emptyN + ' belts';
          } else {
            errorEl.textContent = 'Please select a color for each belt';
          }
        }
        guideIncompleteColors();
      }
      if (ok) {
        if (errorEl) errorEl.style.display = 'none';
        clearIncompletePulse();
      }
      return ok;
    }

    function getSelectedVariantIds() {
      return selections.filter(Boolean).map(function (s) {
        return s.id;
      });
    }

    var stickyAtc = document.querySelector('[data-db-sticky-atc]');
    var stickyAtcBtn = document.querySelector('[data-db-sticky-atc-btn]');
    var stickyAtcDetail = document.querySelector('[data-db-sticky-atc-detail]');
    var mainAtcBtn = document.querySelector('.add_to_cart button');

    function mainAtcInView() {
      if (!mainAtcBtn) return true;
      var rect = mainAtcBtn.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      /* Visible if any of the button is on screen with a little margin */
      return rect.bottom > 48 && rect.top < vh - 24;
    }

    function updateStickyAtc() {
      if (!stickyAtc) return;
      var ready = allSlotsFilled() && quantity >= 1;
      var show = ready && !mainAtcInView();
      /* Keep in DOM for slide animation; visibility via class */
      stickyAtc.hidden = false;
      stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyAtc.classList.toggle('is-visible', show);
      document.body.classList.toggle('db-has-sticky-atc', show);

      if (stickyAtcDetail) {
        if (quantity <= 1) {
          stickyAtcDetail.textContent = '1 belt';
        } else {
          stickyAtcDetail.textContent = quantity + ' belts · colors set';
        }
      }
    }

    if (stickyAtcBtn && mainAtcBtn) {
      stickyAtcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!validate(true)) return;
        mainAtcBtn.click();
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        updateStickyAtc();
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      updateStickyAtc();
    });

    function handleQtyClick(block) {
      clickFirstThumbnail();
      qtyBlocks.forEach(function (b) {
        b.classList.remove('custom_variant_inner_active');
      });
      block.classList.add('custom_variant_inner_active');

      var enteringPlus = isPackPlusBlock(block);
      var wasPlus = packPlus;
      packPlus = enteringPlus;

      if (enteringPlus) {
        /* Entering 4+ from another pack → start at 4 (keep colors that fit). Re-tap keeps size. */
        if (!wasPlus) {
          setQuantity(PACK_PLUS_MIN);
        } else {
          updatePackPlusCard();
          renderChips();
          syncSwatches();
          updateHint();
          updateResetVisibility();
        }
      } else {
        /* Q1–Q3: fixed size; truncates extra belts from 4+ */
        setQuantity(parseQty(block));
        /* Restore 4+ card chrome to base 4 while another pack is selected */
        updatePackPlusCard(PACK_PLUS_MIN);
      }

      var q = quantity;
      var salePriceEls = document.querySelectorAll('.variant-sale-price');
      var discountPrice = block.querySelector('.discount_price_gt');
      var originalPriceEls = document.querySelectorAll('.variant-original-price');
      var pctEls = document.querySelectorAll('[data-db-price-pct]');
      var stacks = document.querySelectorAll('[data-db-price-stack]');
      var saveEl = block.querySelector('.percentage_off, .db-qty-card__save');
      var pctText = '';
      if (saveEl) {
        pctText = (saveEl.textContent || '').trim().replace(/%\s*off/i, '% Off');
      }

      salePriceEls.forEach(function (el) {
        if (q === 1) {
          el.style.display = 'none';
        } else if (discountPrice) {
          el.textContent = discountPrice.textContent.trim();
          el.style.display = '';
        }
      });
      originalPriceEls.forEach(function (el) {
        if (q === 1) el.classList.remove('line-stroke');
        else el.classList.add('line-stroke');
      });
      pctEls.forEach(function (el) {
        if (q === 1 || !pctText) {
          el.hidden = true;
          el.textContent = '';
        } else {
          el.textContent = pctText;
          el.hidden = false;
        }
      });
      stacks.forEach(function (stack) {
        if (q === 1) stack.classList.remove('is-on-sale');
        else stack.classList.add('is-on-sale');
      });
    }

    function rootPath() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    /** Merge duplicate variant ids (same color twice in a pack). */
    function buildCartItems(variantIds) {
      var merged = {};
      for (var i = 0; i < variantIds.length; i++) {
        var id = parseInt(variantIds[i], 10);
        if (!id) continue;
        var key = String(id);
        if (merged[key]) merged[key].quantity += 1;
        else merged[key] = { id: id, quantity: 1 };
      }
      return Object.keys(merged).map(function (k) {
        return merged[k];
      });
    }

    function setButtonState(button, state, label) {
      if (!button) return;
      button.setAttribute('data-db-atc-state', state || '');
      if (state === 'loading' || state === 'success') {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      } else {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
      var labelEl =
        button.querySelector('.button__text, [data-db-atc-label]') || button;
      if (label != null && labelEl) {
        if (!button.dataset.dbAtcDefaultLabel) {
          button.dataset.dbAtcDefaultLabel = (labelEl.textContent || '').trim();
        }
        labelEl.textContent = label;
      }
    }

    function restoreButtonLabel(button) {
      if (!button) return;
      var labelEl =
        button.querySelector('.button__text, [data-db-atc-label]') || button;
      if (button.dataset.dbAtcDefaultLabel && labelEl) {
        labelEl.textContent = button.dataset.dbAtcDefaultLabel;
      }
      setButtonState(button, '');
    }

    /** Force-open cart drawer (works even if theme cart type misconfigured). */
    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer, #cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        try {
          drawer.show();
          return true;
        } catch (err) {}
      }
      /* Legacy popover fallback */
      var note = document.querySelector('cart-notification-drawer');
      if (note && typeof note.show === 'function') {
        try {
          note.show();
          return true;
        } catch (err2) {}
      }
      return false;
    }

    /**
     * Bulk add all pack variants in one request, refresh drawer once, open once.
     * @param {string[]} variantIds
     * @param {boolean} openDrawer — true for ATC, false for checkout redirect
     */
    async function addToCartWithPopup(variantIds, openDrawer) {
      var items = buildCartItems(variantIds);
      if (!items.length) return { ok: false };

      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      var res = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: items,
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname,
        }),
      });

      var responseJson = await res.json().catch(function () {
        return {};
      });

      if (!res.ok) {
        return {
          ok: false,
          error: responseJson.description || responseJson.message || 'Could not add to cart',
        };
      }

      var cartContent = await (await fetch(rootPath() + 'cart.js')).json();
      var sections = responseJson.sections || {};
      var hasSections = sections && Object.keys(sections).length > 0;
      cartContent.sections = sections;

      /*
        Update drawer content first, then open.
        blockCartDrawerOpening: true here — we open explicitly so it always works
        (theme only auto-opens when cartType === "drawer").
      */
      if (hasSections) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );
      } else {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      }

      document.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.items || (responseJson.id ? [responseJson] : []),
            cart: cartContent,
            /* Let theme open if drawer mode; we also force-open below */
            blockCartDrawerOpening: !openDrawer,
          },
        })
      );

      if (openDrawer) {
        /* Explicit open after a tick so content swap can apply */
        setTimeout(function () {
          openCartDrawer();
        }, 50);
      }

      /* Reset selections after successful add; pack-plus returns to 4 empty chips */
      if (packPlus) {
        quantity = PACK_PLUS_MIN;
        selections = [];
        for (var r = 0; r < quantity; r++) selections[r] = null;
        updatePackPlusCard();
      } else {
        selections = selections.map(function () {
          return null;
        });
      }
      activeSlot = 0;
      renderChips();
      syncSwatches();
      updateHint();
      updateResetVisibility();
      updateStickyAtc();

      return { ok: true, cart: cartContent };
    }

    /* Bind swatches */
    swatchForms.forEach(function (form) {
      var custom = form.querySelector('.belt_variant_custom');
      var inv = parseInt((custom && custom.dataset.varinatQuantity) || '0', 10);
      if (inv <= 0) {
        form.classList.add('variant_disabled');
        form.style.opacity = '0.5';
      }
      form.addEventListener('click', function () {
        selectVariantForActiveSlot(form);
      });
      form.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectVariantForActiveSlot(form);
        }
      });
    });

    /* Bind qty cards */
    qtyBlocks.forEach(function (block) {
      block.addEventListener('click', function () {
        handleQtyClick(block);
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function (e) {
        e.preventDefault();
        resetSelections();
      });
    }

    /* ATC / Checkout — capture phase so we win over theme.js if both bound */
    document.querySelectorAll('.add_to_cart button').forEach(function (button) {
      button.addEventListener(
        'click',
        async function (e) {
          if (!validate(true)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          var ids = getSelectedVariantIds();
          if (ids.length === 0) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          if (button.getAttribute('data-db-atc-state') === 'loading') return;

          setButtonState(button, 'loading', 'Adding…');
          try {
            var result = await addToCartWithPopup(ids, true);
            if (result && result.ok) {
              setButtonState(button, 'success', 'Added ✓');
              setTimeout(function () {
                restoreButtonLabel(button);
              }, 1400);
            } else {
              setButtonState(button, 'error', 'Try again');
              setTimeout(function () {
                restoreButtonLabel(button);
              }, 1600);
            }
          } catch (err) {
            setButtonState(button, 'error', 'Try again');
            setTimeout(function () {
              restoreButtonLabel(button);
            }, 1600);
          }
        },
        true
      );
    });

    document.querySelectorAll('.checkout_button button').forEach(function (button) {
      button.addEventListener(
        'click',
        async function (e) {
          if (!validate(true)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          var ids = getSelectedVariantIds();
          if (ids.length === 0) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          if (button.getAttribute('data-db-atc-state') === 'loading') return;

          setButtonState(button, 'loading', 'Checking out…');
          try {
            var result = await addToCartWithPopup(ids, false);
            if (result && result.ok) {
              window.location.href = rootPath() + 'checkout';
            } else {
              setButtonState(button, 'error', 'Try again');
              setTimeout(function () {
                restoreButtonLabel(button);
              }, 1600);
            }
          } catch (err) {
            setButtonState(button, 'error', 'Try again');
            setTimeout(function () {
              restoreButtonLabel(button);
            }, 1600);
          }
        },
        true
      );
    });

    /* Default Most Popular (qty 2) */
    var defaultBlock =
      document.querySelector('.custom_variant_quantity2') ||
      document.querySelector('.custom_variant_inner_active') ||
      qtyBlocks[0];
    if (defaultBlock) handleQtyClick(defaultBlock);

    /* Sample swatch images → solid chip colors (Smokescreen keeps texture) */
    ensureSwatchColors(function () {
      renderChips();
      syncSwatches();
      updateHint();
      updateStickyAtc();
    });

    updateStickyAtc();
  }

  /**
   * ± steppers for cart line quantities (delegated — survives drawer re-render).
   * Dec at min goes to 0 (remove line). Ignores clicks while a change is in flight.
   */
  function initCartQtySteppers() {
    if (document.documentElement.dataset.dbQtyStepperBound === '1') return;
    document.documentElement.dataset.dbQtyStepperBound = '1';

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('[data-db-qty-step]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        var lineItem = btn.closest('line-item');
        if (lineItem && lineItem.getAttribute('aria-busy') === 'true') return;

        var wrap = btn.closest('line-item-quantity');
        var input = wrap && wrap.querySelector('.quantity-input');
        if (!input || input.disabled) return;

        var step = parseInt(input.step || '1', 10) || 1;
        var min = input.min !== '' ? parseInt(input.min, 10) : 1;
        var max = input.max !== '' ? parseInt(input.max, 10) : NaN;
        var current = parseInt(input.value, 10) || 0;
        var isDec = btn.getAttribute('data-db-qty-step') === 'dec';
        var next = isDec ? current - step : current + step;

        /* Allow 0 on decrease so the line can be removed */
        if (isDec && next < min) next = 0;
        if (!isDec && !isNaN(min) && next < min) next = min;
        if (!isNaN(max) && next > max) next = max;
        if (next === current) return;

        if (lineItem) lineItem.setAttribute('aria-busy', 'true');
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      },
      true
    );
  }

  /**
   * Cart-drawer color picker: open swatches + add variant without leaving cart.
   */
  function initCartColorSwatches() {
    if (document.documentElement.dataset.dbCartSwatchesBound === '1') return;
    document.documentElement.dataset.dbCartSwatchesBound = '1';

    function rootPath() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function findPanel(fromEl) {
      var upsell = fromEl && fromEl.closest('[data-db-cart-upsell]');
      if (upsell) {
        var panel = upsell.querySelector('[data-db-cart-swatches]');
        if (panel) return panel;
      }
      return document.querySelector('[data-db-cart-swatches]');
    }

    function setStatus(panel, msg, isError) {
      var el = panel && panel.querySelector('[data-db-cart-swatch-status]');
      if (!el) return;
      if (!msg) {
        el.hidden = true;
        el.textContent = '';
        return;
      }
      el.hidden = false;
      el.textContent = msg;
      el.classList.toggle('is-error', !!isError);
    }

    function isCartPage() {
      var pageType =
        window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.pageType;
      if (pageType === 'cart') return true;
      return /\/cart\/?$/.test(window.location.pathname || '');
    }

    async function addVariantToCart(variantId, swatchBtn) {
      var panel = findPanel(swatchBtn);
      var title = (swatchBtn && swatchBtn.getAttribute('data-variant-title')) || 'color';
      var onCartPage = isCartPage();

      if (swatchBtn) {
        swatchBtn.setAttribute('aria-busy', 'true');
        swatchBtn.disabled = true;
      }
      setStatus(panel, 'Adding ' + title + '…', false);

      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      try {
        var res = await fetch(rootPath() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            sections: sectionsToBundle.join(','),
            sections_url: window.location.pathname,
          }),
        });
        var responseJson = await res.json().catch(function () {
          return {};
        });
        if (!res.ok) {
          throw new Error(
            responseJson.description || responseJson.message || 'Could not add to cart'
          );
        }

        var cartContent = await (await fetch(rootPath() + 'cart.js')).json();
        cartContent.sections = responseJson.sections || {};

        /*
          Cart page: reload so line items + pack ladder pick up the new SKU.
          Flag confetti if Best Value (4+) so it fires after reload on the cart page card.
          Elsewhere (drawer): refresh drawer and keep it open.
        */
        if (onCartPage) {
          setStatus(panel, 'Added ' + title + '…', false);
          if ((cartContent.item_count || 0) >= 4) {
            try {
              sessionStorage.setItem('db_upsell_confetti_pending_page', '1');
              sessionStorage.removeItem('db_upsell_confetti_v1_page');
            } catch (ePending) {}
          }
          window.location.href = rootPath() + 'cart';
          return;
        }

        var hasSections =
          cartContent.sections && Object.keys(cartContent.sections).length > 0;

        if (hasSections) {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                cart: cartContent,
              },
            })
          );
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        }

        if ((cartContent.item_count || 0) >= 4) {
          try {
            sessionStorage.setItem('db_upsell_confetti_pending_drawer', '1');
            sessionStorage.removeItem('db_upsell_confetti_v1_drawer');
          } catch (ePending2) {}
        }

        var drawer = document.querySelector('cart-drawer, #cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          try {
            drawer.show();
          } catch (err) {}
        }
      } catch (err) {
        setStatus(panel, (err && err.message) || 'Could not add color', true);
        if (swatchBtn) {
          swatchBtn.removeAttribute('aria-busy');
          swatchBtn.disabled = false;
        }
      }
    }

    document.addEventListener(
      'click',
      function (e) {
        var openBtn = e.target.closest('[data-db-open-cart-swatches]');
        if (openBtn) {
          e.preventDefault();
          var panel = findPanel(openBtn);
          if (!panel) return;
          var willOpen = panel.hasAttribute('hidden');
          if (willOpen) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
          openBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          if (willOpen) {
            setStatus(panel, '', false);
            try {
              panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            } catch (err2) {}
          }
          return;
        }

        var closeBtn = e.target.closest('[data-db-close-cart-swatches]');
        if (closeBtn) {
          e.preventDefault();
          var panelClose = findPanel(closeBtn);
          if (panelClose) panelClose.setAttribute('hidden', '');
          var openers = document.querySelectorAll('[data-db-open-cart-swatches]');
          openers.forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
          return;
        }

        var swatch = e.target.closest('[data-db-cart-add-variant]');
        if (swatch && !swatch.disabled) {
          e.preventDefault();
          var id = swatch.getAttribute('data-db-cart-add-variant');
          if (id) addVariantToCart(id, swatch);
        }
      },
      false
    );
  }

  /**
   * ★★★★★ Excellent → smooth-scroll to Popular Reviews (or first reviews block).
   */
  function initScrollToReviews() {
    if (document.documentElement.dataset.dbScrollReviewsBound === '1') return;
    document.documentElement.dataset.dbScrollReviewsBound = '1';

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('[data-db-scroll-to-reviews]');
        if (!btn) return;
        e.preventDefault();

        var target =
          document.querySelector('.db-reviews') ||
          document.querySelector('.shopify-section--popular-reviews') ||
          document.querySelector('[id^="shopify-section"][id*="review"]') ||
          document.querySelector('#junip-reviews') ||
          document.querySelector('[data-junip-reviews]');

        if (!target) return;

        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (err) {
          target.scrollIntoView(true);
        }

        var heading = target.querySelector('h2, .db-reviews__heading');
        if (heading) {
          if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
          try {
            heading.focus({ preventScroll: true });
          } catch (err2) {}
        }
      },
      false
    );
  }

  /* Shared across bootAll re-runs so we don't stack MutationObservers */
  var expressSettleTimers = new WeakMap();
  var expressSettleObservers = new WeakMap();

  /**
   * Cart page shipping estimator:
   * - Only rendered in Liquid for 1 belt; hide if cart grows to 2+ via AJAX
   * - After estimate, show fixed $5.57 (matches db-cart-upsell shipping_single)
   */
  function initCartShippingEstimator() {
    function hideIfMultiBelt(cart) {
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
      if (count === null) return;
      var blocks = document.querySelectorAll('[data-db-shipping-estimator]');
      for (var i = 0; i < blocks.length; i++) {
        if (count >= 2) {
          blocks[i].hidden = true;
          blocks[i].setAttribute('hidden', '');
        } else if (count === 1) {
          blocks[i].hidden = false;
          blocks[i].removeAttribute('hidden');
        }
      }
    }

    function patchFormatRates() {
      var Ctor = window.customElements && customElements.get('shipping-estimator');
      if (!Ctor || !Ctor.prototype || Ctor.prototype.__dbSingleBeltRatePatched) return;
      Ctor.prototype.__dbSingleBeltRatePatched = true;

      var original = Ctor.prototype._formatShippingRates;
      Ctor.prototype._formatShippingRates = function (shippingRates) {
        if (!this.hasAttribute('data-db-single-belt-rate')) {
          if (typeof original === 'function') {
            return original.call(this, shippingRates);
          }
          return;
        }

        var display = this.getAttribute('data-rate-display') || '$5.57';
        var name = this.getAttribute('data-rate-name') || 'Standard';
        var oneResult =
          (window.themeVariables &&
            window.themeVariables.strings &&
            window.themeVariables.strings.shippingEstimatorOneResult) ||
          'There is one shipping rate available for your order:';

        this.resultsElement.innerHTML =
          '<div class="v-stack gap-2">' +
          '<p>' +
          oneResult +
          '</p>' +
          '<ul class="list-disc" role="list">' +
          '<li>' +
          name +
          ': ' +
          display +
          '</li>' +
          '</ul>' +
          '</div>';
      };
    }

    patchFormatRates();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shipping-estimator').then(patchFormatRates);
    }

    if (document.documentElement.dataset.dbShipEstBound === '1') return;
    document.documentElement.dataset.dbShipEstBound = '1';

    document.addEventListener(
      'cart:change',
      function (event) {
        var cart = event.detail && event.detail.cart;
        hideIfMultiBelt(cart);
      },
      false
    );
  }

  /**
   * Cart drawer express wallets (Shop / Apple / Google): hide until Shopify finishes
   * eligibility so unsupported buttons don't flash then vanish (Clarity noise).
   */
  function initCartExpressSettle() {
    var QUIET_MS = 380;
    var MAX_WAIT_MS = 1100;

    function hasVisibleWallets(el) {
      if (!el) return false;
      var nodes = el.querySelectorAll(
        'shopify-accelerated-checkout-cart, shopify-accelerated-checkout, ' +
          '.shopify-payment-button, .shopify-payment-button__button, ' +
          'iframe, button, a[role="button"], [role="button"]'
      );
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var style = window.getComputedStyle(n);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
          continue;
        }
        var r = n.getBoundingClientRect();
        if (r.width >= 8 && r.height >= 8) return true;
      }
      /* Custom elements often size the host after shadow render */
      if (el.childElementCount > 0 && el.scrollHeight >= 24) return true;
      return false;
    }

    function finish(el) {
      var t = expressSettleTimers.get(el);
      if (t) {
        clearTimeout(t.quiet);
        clearTimeout(t.max);
        expressSettleTimers.delete(el);
      }
      var obs = expressSettleObservers.get(el);
      if (obs) {
        try {
          obs.disconnect();
        } catch (e) {}
        expressSettleObservers.delete(el);
      }

      el.classList.remove('is-settled', 'is-empty');
      if (hasVisibleWallets(el)) {
        el.classList.add('is-settled');
      } else {
        el.classList.add('is-empty');
      }
    }

    function scheduleFinish(el) {
      var t = expressSettleTimers.get(el) || {};
      if (t.quiet) clearTimeout(t.quiet);
      t.quiet = setTimeout(function () {
        finish(el);
      }, QUIET_MS);
      expressSettleTimers.set(el, t);
    }

    function isCartDrawerOpen(el) {
      var drawer = el && el.closest ? el.closest('cart-drawer') : null;
      if (!drawer) drawer = document.querySelector('cart-drawer');
      return !!(drawer && drawer.hasAttribute('open'));
    }

    function arm(el) {
      if (!el || el.nodeType !== 1) return;

      /* Never hydrate wallets while the drawer is closed — causes bottom-right leak */
      if (!isCartDrawerOpen(el)) {
        el.classList.remove('is-settled');
        el.classList.add('is-empty');
        var existingClosed = expressSettleTimers.get(el);
        if (existingClosed) {
          clearTimeout(existingClosed.quiet);
          clearTimeout(existingClosed.max);
          expressSettleTimers.delete(el);
        }
        var prevClosed = expressSettleObservers.get(el);
        if (prevClosed) {
          try {
            prevClosed.disconnect();
          } catch (eClosed) {}
          expressSettleObservers.delete(el);
        }
        return;
      }

      el.classList.remove('is-settled', 'is-empty');

      var prev = expressSettleObservers.get(el);
      if (prev) {
        try {
          prev.disconnect();
        } catch (e2) {}
      }

      var existing = expressSettleTimers.get(el);
      if (existing) {
        clearTimeout(existing.quiet);
        clearTimeout(existing.max);
      }

      try {
        if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
          Shopify.PaymentButton.init();
        }
      } catch (e3) {}

      var obs = new MutationObserver(function () {
        scheduleFinish(el);
      });
      obs.observe(el, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
      });
      expressSettleObservers.set(el, obs);

      var state = {
        quiet: null,
        max: setTimeout(function () {
          finish(el);
        }, MAX_WAIT_MS),
      };
      expressSettleTimers.set(el, state);

      /* If wallets already present, still wait a short quiet window for removals */
      scheduleFinish(el);
    }

    function armAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var list = scope.querySelectorAll
        ? scope.querySelectorAll('.cart-drawer__express')
        : [];
      /* If root itself is the express node */
      if (root && root.classList && root.classList.contains('cart-drawer__express')) {
        arm(root);
      }
      for (var i = 0; i < list.length; i++) arm(list[i]);
    }

    armAll(document);

    /* Listeners once per page */
    if (document.documentElement.dataset.dbExpressSettleBound === '1') return;
    document.documentElement.dataset.dbExpressSettleBound = '1';

    document.addEventListener(
      'cart:change',
      function () {
        /* Footer is replaced after cart updates — re-arm after DOM swap */
        setTimeout(function () {
          armAll(document);
        }, 40);
      },
      false
    );

    document.addEventListener(
      'cart:refresh',
      function () {
        setTimeout(function () {
          armAll(document);
        }, 40);
      },
      false
    );

    /* When drawer opens, wallets may hydrate only once visible */
    document.addEventListener(
      'dialog:after-show',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (t.matches && (t.matches('cart-drawer') || t.id === 'cart-drawer')) {
          setTimeout(function () {
            armAll(t);
          }, 30);
        }
      },
      true
    );

    /* On close, force wallets off so they can't stick on the page */
    document.addEventListener(
      'dialog:after-hide',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (t.matches && (t.matches('cart-drawer') || t.id === 'cart-drawer')) {
          var nodes = t.querySelectorAll('.cart-drawer__express');
          for (var i = 0; i < nodes.length; i++) {
            nodes[i].classList.remove('is-settled');
            nodes[i].classList.add('is-empty');
          }
        }
      },
      true
    );

    /* Attribute fallback if theme toggles open without dialog events */
    var drawerEl = document.querySelector('cart-drawer, #cart-drawer');
    if (drawerEl && window.MutationObserver) {
      new MutationObserver(function () {
        if (drawerEl.hasAttribute('open')) {
          setTimeout(function () {
            armAll(drawerEl);
          }, 40);
        } else {
          var nodes2 = drawerEl.querySelectorAll('.cart-drawer__express');
          for (var j = 0; j < nodes2.length; j++) {
            nodes2[j].classList.remove('is-settled');
            nodes2[j].classList.add('is-empty');
          }
        }
      }).observe(drawerEl, { attributes: true, attributeFilter: ['open'] });
    }

    /* Fallback: observe cart-drawer subtree for express nodes injected later */
    var drawer = document.querySelector('cart-drawer, #cart-drawer');
    if (drawer && window.MutationObserver) {
      var drawerObs = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var nodes = mutations[m].addedNodes;
          for (var n = 0; n < nodes.length; n++) {
            var node = nodes[n];
            if (node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('cart-drawer__express')) {
              arm(node);
            } else if (node.querySelectorAll) {
              var found = node.querySelectorAll('.cart-drawer__express');
              for (var f = 0; f < found.length; f++) arm(found[f]);
            }
          }
        }
      });
      drawerObs.observe(drawer, { childList: true, subtree: true });
    }
  }

  /**
   * Best Value confetti — burst when cart hits 4 belts.
   * Runs for both cart page and open cart drawer (separate session flags so the
   * closed drawer copy can't steal the page celebration).
   */
  function initCartUpsellConfetti() {
    var COLORS = ['#bc7b2f', '#9a6426', '#e8c07a', '#2f7a3e', '#3d9a52', '#141210', '#fff8ee'];
    var KEY_PAGE = 'db_upsell_confetti_v1_page';
    var KEY_DRAWER = 'db_upsell_confetti_v1_drawer';
    var PENDING_PAGE = 'db_upsell_confetti_pending_page';
    var PENDING_DRAWER = 'db_upsell_confetti_pending_drawer';

    function prefersReduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function isCartPage() {
      var pageType =
        window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.pageType;
      if (pageType === 'cart') return true;
      return /\/cart\/?$/.test(window.location.pathname || '');
    }

    function getContext(root) {
      if (root && root.closest && root.closest('cart-drawer')) return 'drawer';
      if (isCartPage()) return 'page';
      return 'other';
    }

    function isEligibleRoot(root) {
      if (!root || root.getAttribute('data-db-max') !== '1') return false;
      var count = parseInt(root.getAttribute('data-belt-count') || '0', 10);
      if (count < 4) return false;

      var drawer = root.closest('cart-drawer');
      if (drawer) {
        /* Only celebrate the drawer card when the drawer is open */
        return drawer.hasAttribute('open');
      }
      /* Cart page (or other) — celebrate visible page card */
      return true;
    }

    function sessionKeyFor(context) {
      return context === 'drawer' ? KEY_DRAWER : KEY_PAGE;
    }

    function pendingKeyFor(context) {
      return context === 'drawer' ? PENDING_DRAWER : PENDING_PAGE;
    }

    function shouldCelebrate(context) {
      try {
        if (sessionStorage.getItem(pendingKeyFor(context)) === '1') return true;
        if (sessionStorage.getItem(sessionKeyFor(context)) === '1') return false;
        return true;
      } catch (e) {
        return true;
      }
    }

    function markCelebrated(context) {
      try {
        sessionStorage.setItem(sessionKeyFor(context), '1');
        sessionStorage.removeItem(pendingKeyFor(context));
      } catch (e) {}
    }

    function clearAllWhenBelowMax() {
      try {
        sessionStorage.removeItem(KEY_PAGE);
        sessionStorage.removeItem(KEY_DRAWER);
        sessionStorage.removeItem(PENDING_PAGE);
        sessionStorage.removeItem(PENDING_DRAWER);
      } catch (e) {}
    }

    function burst(canvas) {
      if (!canvas || prefersReduced()) return;
      var root = canvas.closest('[data-db-cart-upsell]');
      if (!isEligibleRoot(root)) return;

      var context = getContext(root);
      if (context === 'other') return;
      if (!shouldCelebrate(context)) return;

      var rect = root.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.max(1, Math.floor(rect.width));
      var h = Math.max(1, Math.floor(rect.height));
      if (w < 8 || h < 8) return;

      /* Claim after size check so a zero-size pass can retry */
      markCelebrated(context);

      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      canvas.hidden = false;

      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var particles = [];
      var n = 56;
      var originX = w * 0.5;
      var originY = h * 0.35;
      for (var i = 0; i < n; i++) {
        var angle = (Math.PI * 2 * i) / n + (Math.random() - 0.5) * 0.5;
        var speed = 2.2 + Math.random() * 3.8;
        particles.push({
          x: originX + (Math.random() - 0.5) * 20,
          y: originY + (Math.random() - 0.5) * 10,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - (1.5 + Math.random() * 2),
          g: 0.12 + Math.random() * 0.08,
          w: 3 + Math.random() * 4,
          h: 2 + Math.random() * 3,
          rot: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.25,
          color: COLORS[i % COLORS.length],
          life: 1,
          decay: 0.012 + Math.random() * 0.01,
        });
      }

      var start = null;
      var maxMs = 1500;

      function frame(ts) {
        if (start === null) start = ts;
        var elapsed = ts - start;
        ctx.clearRect(0, 0, w, h);

        var alive = 0;
        for (var p = 0; p < particles.length; p++) {
          var pt = particles[p];
          if (pt.life <= 0) continue;
          alive++;
          pt.vy += pt.g;
          pt.x += pt.vx;
          pt.y += pt.vy;
          pt.vx *= 0.99;
          pt.rot += pt.vr;
          pt.life -= pt.decay;

          ctx.save();
          ctx.translate(pt.x, pt.y);
          ctx.rotate(pt.rot);
          ctx.globalAlpha = Math.max(0, pt.life);
          ctx.fillStyle = pt.color;
          ctx.fillRect(-pt.w / 2, -pt.h / 2, pt.w, pt.h);
          ctx.restore();
        }

        if (alive > 0 && elapsed < maxMs) {
          requestAnimationFrame(frame);
        } else {
          ctx.clearRect(0, 0, w, h);
          canvas.hidden = true;
        }
      }
      requestAnimationFrame(frame);
    }

    function scan() {
      var nodes = document.querySelectorAll('[data-db-cart-upsell][data-db-max="1"] [data-db-confetti]');
      for (var i = 0; i < nodes.length; i++) {
        burst(nodes[i]);
      }
    }

    function scanSoon(delay) {
      setTimeout(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(scan);
        });
      }, delay || 80);
    }

    /* Allow re-celebrate when count drops below 4 then hits max again */
    document.addEventListener(
      'cart:change',
      function (event) {
        var cart = event.detail && event.detail.cart;
        var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        if (n !== null && n < 4) {
          clearAllWhenBelowMax();
        }
        scanSoon(150);
        /* Cart page section can re-render slightly later */
        if (isCartPage()) scanSoon(400);
      },
      false
    );

    if (document.documentElement.dataset.dbConfettiBound === '1') {
      scanSoon(100);
      return;
    }
    document.documentElement.dataset.dbConfettiBound = '1';

    document.addEventListener(
      'dialog:after-show',
      function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('cart-drawer')) {
          scanSoon(120);
        }
      },
      true
    );

    /* Cart page load (and general boot) — longer delay so layout has width */
    scanSoon(isCartPage() ? 280 : 120);

    /* Extra pass on cart page after fonts/layout settle */
    if (isCartPage()) {
      scanSoon(600);
    }
  }

  /**
   * Junip product summary: hide (123) and show
   * “★★★★★ 4.8/5.0 25K+ happy waists”
   * Force solid full stars; Junip injects async — watch + enhance.
   */
  function initJunipSummaryTrustLine() {
    var COPY_CLASS = 'db-junip-summary__copy';
    var COPY_HTML =
      '<strong>4.8/5.0</strong>' +
      ' <span class="db-junip-summary__dot" aria-hidden="true">•</span> ' +
      '<strong>25K+</strong> <span class="db-junip-summary__phrase">happy waists</span>';
    var ARIA = '4.8 out of 5.0, 25K+ happy waists';

    function enhance(container) {
      if (!container) return;

      var count = container.querySelector('.junip-product-summary-review-count');
      if (count) {
        count.setAttribute('hidden', '');
        count.setAttribute('aria-hidden', 'true');
      }

      /* Solid full-star fill (matches ref: five filled stars) */
      var filled = container.querySelector('.junip-stars-filled');
      if (filled) {
        filled.style.setProperty('--junip-star-fill', '100%');
        filled.style.width = '100%';
      }

      var copy = container.querySelector('.' + COPY_CLASS);
      if (!copy) {
        copy = document.createElement('span');
        copy.className = COPY_CLASS;
        container.appendChild(copy);
      }
      if (copy.innerHTML !== COPY_HTML) {
        copy.innerHTML = COPY_HTML;
      }

      if (container.getAttribute('role') === 'img' || container.hasAttribute('aria-label')) {
        container.setAttribute('aria-label', ARIA);
      }
    }

    function scan() {
      document
        .querySelectorAll('.junip-product-summary-star-ratings-container')
        .forEach(enhance);
    }

    scan();

    if (document.documentElement.dataset.dbJunipTrustObs === '1') return;
    document.documentElement.dataset.dbJunipTrustObs = '1';

    var obs = new MutationObserver(function () {
      scan();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    /* Junip often hydrates a beat after DOMContentLoaded */
    setTimeout(scan, 400);
    setTimeout(scan, 1200);
    setTimeout(scan, 3000);
  }

  function bootAll() {
    initQtyScrollDiscoverability();
    initCartQtySteppers();
    initCartColorSwatches();
    initScrollToReviews();
    initJunipSummaryTrustLine();
    initCartExpressSettle();
    initCartShippingEstimator();
    initCartUpsellConfetti();
    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(bootAll, 0);
    });
  } else {
    setTimeout(bootAll, 0);
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-db-color-picker]').forEach(function (el) {
      delete el.dataset.dbChipsBound;
    });
    document.querySelectorAll('[data-db-qty-scroll]').forEach(function (el) {
      delete el.dataset.dbQtyScrollBound;
    });
    setTimeout(bootAll, 0);
  });
})();
